/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const kindEnumSchema = z.enum(["courier", "pickup"]).describe("* `courier` - Доставка курьером\n* `pickup` - Самовывоз");
